import React, { FunctionComponent, SVGProps } from "react";

export const SlidersIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      {...props}
      fill="none"
      height="18"
      viewBox="0 0 24 18"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M9 1.74927c-.96649 0-1.75.78351-1.75 1.75002 0 .96649.78349 1.74998 1.75 1.74998s1.75-.78349 1.75-1.74998c0-.96651-.78351-1.75002-1.75-1.75002ZM5.83697 2.74928C6.17555 1.31594 7.46321.249268 9 .249268c1.5368 0 2.8244 1.066672 3.163 2.500022L23 2.74919c.4142 0 .75.33578.75.75 0 .41421-.3358.75-.75.75l-10.837.0001C11.8245 5.68264 10.5368 6.74927 9 6.74927c-1.53679 0-2.82446-1.06663-3.16304-2.49999L.999987 4.24919c-.414214 0-.749994-.3358-.749987-.75001.000007-.41421.3358-.74999.75001-.74999l4.83696.00009ZM17 12.7493c-.9665 0-1.75.7835-1.75 1.75s.7835 1.75 1.75 1.75 1.75-.7835 1.75-1.75-.7835-1.75-1.75-1.75Zm-3.163 1c.3385-1.4334 1.6262-2.5 3.163-2.5 1.5368 0 2.8245 1.0666 3.163 2.5H23c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-2.837c-.3386 1.4333-1.6262 2.5-3.163 2.5-1.5368 0-2.8245-1.0667-3.163-2.5H1c-.414212 0-.749999-.3358-.75-.75-.000001-.4142.335785-.75.75-.75h12.837Z"
        fill="#64748B"
        fillRule="evenodd"
      />
    </svg>
  );
};
